
import { AxiosResponse } from "axios";

import Vue from "vue";
import Component from "vue-class-component";

import { Prop } from "vue-property-decorator";

import { WebAPI } from "../web-api";
import { Snackbar } from "../snackbar";

@Component({
  components: {},
})
export default class LoadingExternalPage extends Vue {
  @Prop({ type: String })
  public appName: string;

  @Prop({ type: String })
  public objectId: string;

  public invalidAppName = false;

  public appMethods: any = {
    degust: {
      displayName: "Degust",
      method: this.redirectToDegust,
    },
  };

  get access_token(): string | undefined {
    let token = this.$route.query.access_token;
    if (token != null) {
      return token.toString();
    }
    return undefined;
  }

  public async created() {
    const app = this.appMethods[this.appName];
    if (!app) {
      this.invalidAppName = true;
    } else {
      await app.method(this.objectId);
    }
  }

  public async mounted() {}

  public async redirectToDegust(fileId: string) {
    const response = await WebAPI.sendToDegust(fileId, this.access_token);
    if (response.data.status == 200) {
      window.location.href = response.data.redirect;
    } else {
      console.log(response);
      console.log(`Failed to send to Degust - backend error ?`);
    }
  }
}
